// extracted by mini-css-extract-plugin
export default {"toastWrapper":"Toast_toastWrapper__xCbTD","toast":"Toast_toast__DKvnV","removeButton":"Toast_removeButton__CLIiz","scrollBackground":"Toast_scrollBackground__i4aXI"};